import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=f13e3e58&scoped=true"
import script from "./Tabs.js?vue&type=script&lang=js&external"
export * from "./Tabs.js?vue&type=script&lang=js&external"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=f13e3e58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13e3e58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import VTabs from '@/agilis/wrappers/VTabs/VTabs.vue'
installComponents(component, {VBtn,VCard,VCardText,VIcon,VTab,VTabItem,VTabs})
